import { config, createSonicSearchClient } from "@sonic-equipment/ui";

export const searchClient = createSonicSearchClient({
    appId: config.ALGOLIA_APP_ID,
    apiKey: config.ALGOLIA_API_KEY,
    host: config.ALGOLIA_HOST,
});
